export default "__VITE_ASSET__30f00b48__"